/** Map of ISO 3166-1 alpha-2 country codes to country names. */
export const COUNTRY_NAMES: Record<string, string> = {
    AT: "Austria",
    AU: "Australia",
    BE: "Belgium",
    CA: "Canada",
    CH: "Switzerland",
    CN: "China",
    CZ: "Czechia",
    DE: "Germany",
    DK: "Denmark",
    ES: "Spain",
    FI: "Finland",
    FR: "France",
    GB: "United Kingdom",
    HR: "Croatia",
    HU: "Hungary",
    IE: "Ireland",
    IN: "India",
    IT: "Italy",
    JP: "Japan",
    KR: "South Korea",
    NL: "Netherlands",
    NO: "Norway",
    NZ: "New Zealand",
    PL: "Poland",
    PT: "Portugal",
    RO: "Romania",
    RS: "Serbia",
    SE: "Sweden",
    SI: "Slovenia",
    SK: "Slovakia",
    US: "United States",
};

/** Format a country code for display: "DE - Germany" */
export function formatCountry(code: string): string {
    const name = COUNTRY_NAMES[code];
    return name ? `${code} - ${name}` : code;
}
